export const ORG_TYPE_OPTIONS = [
  { label: "POC", value: "POC" },
  { label: "Production", value: "PROD" },
  { label: "Homolog", value: "HOMOLOG" },
  { label: "Sandbox", value: "SANDBOX" },
];
